import { SvgIconComponent } from "@mui/icons-material";
import {
  FC,
  HTMLAttributeAnchorTarget,
  MouseEventHandler,
  ReactNode,
} from "react";
import css from "./UserMenuItem.module.css";
import { Link, To } from "react-router-dom";

interface UserMenuItemProps {
  Icon: SvgIconComponent;
  to?: To;
  target?: HTMLAttributeAnchorTarget;
  onClick?: MouseEventHandler;
  children?: ReactNode;
  disabled?: boolean;
}

const UserMenuItem: FC<UserMenuItemProps> = ({
  Icon,
  to,
  target,
  onClick,
  children,
  disabled,
}) => {
  if (!onClick) onClick = () => {};
  if (!to) {
    const oldOnclick = onClick;
    onClick = (event) => {
      oldOnclick(event);
      event.preventDefault();
    };
  }
  return (
    <li className={css.item + " " + (disabled ? css.disabled : "")}>
      <Link to={to || "#"} target={target} onClick={onClick}>
        <Icon className={css.icon} />
        {children}
      </Link>
    </li>
  );
};

export default UserMenuItem;
